import React from 'react';
import { TDR, resolveInboundDirect } from 'tdr-common';
import { DirectInboundNotice } from '../../large-group-inbound-notice/DirectInboundNotice';

export type InboundDirectSectionProps = {
	restaurant: TDR.Restaurant;
	section: TDR.SearchConfig.InboundDirectSection;
};

export function InboundDirectSection({ restaurant, section }: InboundDirectSectionProps) {
	const { phone, email } = resolveInboundDirect(section, restaurant);
	if (!phone && !email) {
		return null;
	}

	return (
		<section className='px-5 pt-6 sm:px-0 sm:pt-4'>
			<DirectInboundNotice restaurant={restaurant} phone={phone} email={email} />
		</section>
	);
}
